import React, { useContext } from 'react';
import notFound from '../../assets/images/notFound.svg';
import MessagesContext from '../../contexts/messagesContext';
import { makeStyles } from '@material-ui/core';
import PatientFileHeader from '../PatientFileHeader';
import { useLocation, useParams } from 'react-router-dom';
import useCheckMobileScreen from '../../hooks/useWidth';

const styles = makeStyles({
    mainContainer: ({ isPatientFile }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: isPatientFile ? 'calc(100vh - 103px)' : '100%',
        background: '#fff'
    }),
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '330px',
        '& span': {
            textAlign: 'center',
            direction: 'initial'
        },
        '& img': {
            marginBottom: '26px'
        }
    }
});
const NotFound = () => {
    const { messages } = useContext(MessagesContext);
    const params = useParams();
    const isMobile = useCheckMobileScreen();
    const isPatientFile = params?.id && isMobile;
    const classes = styles({ isPatientFile });
    const { pathname } = useLocation();
    const lastParam = pathname?.split('/')?.at(-1);
    const component = lastParam === 'forms' ? 'visit' : lastParam;
    const title = messages?.sidebar?.[component];

    return (
        <>
            {isPatientFile && <PatientFileHeader title={title} />}
            <div className={!isPatientFile && 'container'}>
                <div className={classes.mainContainer}>
                    <div className={classes.wrapper}>
                        <img src={notFound} alt="notFound" />
                        <span>{messages.notFound1}</span>
                        <span>{messages.notFound2}</span>
                    </div>
                </div>
            </div>
        </>
    );
};
export default NotFound;
